(function () {
  'use strict';

  if (window.SKHomeChoiceBridge) {
    window.SKHomeChoiceBridge.init(document);
    return;
  }

  var selector = '[data-sk-home-choice]';

  function track(name, params) {
    if (window.Shopify && window.Shopify.designMode) return;
    var payload = Object.assign({ event: name, page_path: window.location.pathname }, params || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (typeof window.gtag === 'function' && !window.google_tag_manager) {
      var gtagParams = Object.assign({}, payload);
      delete gtagParams.event;
      window.gtag('event', name, gtagParams);
    }
  }

  function syncLauncherVisibility() {
    if (!document.body) return;
    var visible = document.querySelector(selector + '[data-sk-choice-visible="true"]');
    document.body.classList.toggle('sk-home-choice-visible', Boolean(visible));
  }

  function initRoot(root) {
    if (!root || root.__skHomeChoiceCleanup) return;

    var routeLinks = root.querySelectorAll('[data-sk-home-choice-route]');
    var diagnosisButton = root.querySelector('[data-sk-home-choice-diagnosis]');
    var diagnosisRegion = root.querySelector('[data-sk-home-choice-diagnosis-region]');
    var launcherObserver = null;
    var viewObserver = null;
    var viewed = false;

    function onRouteClick(event) {
      track('home_choice_route_click', {
        route_id: event.currentTarget.getAttribute('data-sk-home-choice-route') || 'unknown'
      });
    }

    function onDiagnosisClick(event) {
      track('home_choice_diagnosis_click', {});
      var diagnosisLink = event.currentTarget;
      var fallbackUrl = diagnosisLink.href;
      var conciergeRoot = document.querySelector('#sk-concierge-root');
      var launcher = conciergeRoot && conciergeRoot.querySelector('[data-sk-concierge-launch]');
      if (!launcher) return;

      event.preventDefault();
      conciergeRoot.__skConciergeReturnFocus = diagnosisLink;

      function onReady() {
        conciergeRoot.removeEventListener('sk:concierge:error', onError);
      }

      function onError() {
        conciergeRoot.removeEventListener('sk:concierge:ready', onReady);
        conciergeRoot.__skConciergeReturnFocus = null;
        window.location.assign(fallbackUrl);
      }

      conciergeRoot.addEventListener('sk:concierge:ready', onReady, { once: true });
      conciergeRoot.addEventListener('sk:concierge:error', onError, { once: true });
      launcher.click();
    }

    routeLinks.forEach(function (link) {
      link.addEventListener('click', onRouteClick);
    });
    if (diagnosisButton) diagnosisButton.addEventListener('click', onDiagnosisClick);

    if (!(window.Shopify && window.Shopify.designMode) && 'IntersectionObserver' in window) {
      viewObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var visible = entry.isIntersecting && entry.intersectionRatio >= .15;
          if (visible && !viewed) {
            viewed = true;
            track('home_choice_view', {});
            viewObserver.disconnect();
          }
        });
      }, { threshold: [0, .15] });
      viewObserver.observe(root);

      if (diagnosisRegion) {
        launcherObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var visible = entry.isIntersecting && entry.intersectionRatio >= .15;
            root.setAttribute('data-sk-choice-visible', visible ? 'true' : 'false');
          });
          syncLauncherVisibility();
        }, { threshold: [0, .15] });
        launcherObserver.observe(diagnosisRegion);
      }
    }

    root.__skHomeChoiceCleanup = function () {
      routeLinks.forEach(function (link) {
        link.removeEventListener('click', onRouteClick);
      });
      if (diagnosisButton) diagnosisButton.removeEventListener('click', onDiagnosisClick);
      if (launcherObserver) launcherObserver.disconnect();
      if (viewObserver) viewObserver.disconnect();
      root.removeAttribute('data-sk-choice-visible');
      root.__skHomeChoiceCleanup = null;
      syncLauncherVisibility();
    };
  }

  function eachRoot(scope, callback) {
    if (!scope) return;
    if (scope.matches && scope.matches(selector)) callback(scope);
    scope.querySelectorAll(selector).forEach(callback);
  }

  function init(scope) {
    eachRoot(scope || document, initRoot);
  }

  function cleanup(scope) {
    eachRoot(scope, function (root) {
      if (root.__skHomeChoiceCleanup) root.__skHomeChoiceCleanup();
    });
  }

  window.SKHomeChoiceBridge = { init: init, cleanup: cleanup };
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { cleanup(event.target); });
  init(document);
})();
